import { IonButton, IonIcon } from '@ionic/react';
import {
  checkmarkCircle,
  reorderTwoOutline,
  trashOutline,
} from 'ionicons/icons';
import React from 'react';
import { formatStepDuration } from '../../automation/runProgress';
import type { AutomationActionType } from '../../types/AutomationWorkflow.types';
import { getAutomationBlockIcon } from './automationBlockIcons';

export interface StepDragHandlers {
  onDragStart: (event: React.DragEvent) => void;
  onDragOver: (event: React.DragEvent) => void;
  onDrop: (event: React.DragEvent) => void;
  onDragEnd: () => void;
}

export interface StepRunStatus {
  running: boolean;
  durationMs?: number;
}

export const StepCardHeader: React.FC<{
  actionType: AutomationActionType;
  title: string;
  subtitle: string;
  status: StepRunStatus;
  onSelect: () => void;
  onRemove: () => void;
}> = ({ actionType, title, subtitle, status, onSelect, onRemove }) => (
  <>
    <button
      type="button"
      className="automation-step-card-main"
      onClick={onSelect}
    >
      <IonIcon
        className="automation-step-drag-handle"
        icon={reorderTwoOutline}
        aria-hidden
      />
      <span
        className={`automation-step-icon-tile automation-step-icon-tile-${actionType.replace(/_/g, '-')}`}
      >
        <IonIcon icon={getAutomationBlockIcon(actionType)} />
      </span>
      <div className="automation-step-card-heading">
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
      <StepStatusBadge status={status} />
    </button>
    <IonButton
      fill="clear"
      color="medium"
      className="automation-step-delete"
      aria-label="Remove step"
      onClick={onRemove}
    >
      <IonIcon slot="icon-only" icon={trashOutline} />
    </IonButton>
  </>
);

const StepStatusBadge: React.FC<{ status: StepRunStatus }> = ({ status }) => {
  if (status.running) {
    return (
      <span className="automation-step-status running">
        <span className="automation-step-status-dot" aria-hidden />
        Running
      </span>
    );
  }

  if (status.durationMs == null) return null;

  return (
    <span className="automation-step-status done">
      <IonIcon icon={checkmarkCircle} aria-hidden />
      {formatStepDuration(status.durationMs)}
    </span>
  );
};

export const OptionChip: React.FC<{
  label: string;
  active: boolean;
  onToggle: () => void;
}> = ({ label, active, onToggle }) => (
  <button
    type="button"
    className={`automation-option-chip${active ? ' active' : ''}`}
    onClick={onToggle}
  >
    {label}
  </button>
);

export const PathTokenHint: React.FC = () => (
  <p className="automation-token-hint">
    Drop <span>{'{genre}'}</span>, <span>{'{artist}'}</span>,{' '}
    <span>{'{bpm}'}</span> or <span>{'{year}'}</span> into the path to build
    folders as you go.
  </p>
);
